module.exports = __webpack_public_path__ + "static/media/MenuDataAnnotation.487ba9f2.svg";